angular.module('unergie.main')
.directive('userInfoAccountTag', (DataAccessTags, AlertManager, ErrorCatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/states/userContractInfo/component/account/userInfoAccountTag.html',
        link($scope) {
            let tagRef = []
            let tagRefBackup = []
            $scope.tags = []
            $scope.tagFields = {}
            $scope.tagPayload = { id: '' }

            const refreshTags = function () {
                tagRef = []
                tagRefBackup.forEach((datum) => {
                    if (!_.find($scope.tags, { id_tag: datum.id })) {
                        return tagRef.push({ value: datum.id, label: datum.id })
                    }
                })
                $scope.tagFields = {
                    id: {
                        required: true,
                        label: 'Nom',
                        placeholder: 'Nom',
                        type: 'select',
                        enum: tagRef,
                    },
                }
            }

            const refreshAccountTags = () =>
                DataAccessTags.accountTags({ id_account: $scope.account.id }).$promise.then((data) => {
                    $scope.tags = data
                    return refreshTags() }).catch(ErrorCatcher)


            const resetTagPayload = function () {
                const tagTemplate = { id: '' }
                return ($scope.tagPayload = angular.copy(tagTemplate))
            }

            $scope.addTag = () =>
                DataAccessTags.addAccountTag({ id_account: $scope.account.id, id_tag: $scope.tagPayload.id }).$promise.then(() => {
                    AlertManager.success('Tag ajouté')
                    resetTagPayload()
                    return refreshAccountTags() }).catch(ErrorCatcher)


            $scope.deleteTag = (tag) =>
                DataAccessTags.delAccountTag({ id_account: $scope.account.id, id_tag: tag.id }).$promise.then(() => {
                    AlertManager.success('Tag retiré')
                    return refreshAccountTags() }).catch(ErrorCatcher)


            const activate = function () {
                refreshAccountTags()
                DataAccessTags.getTags().$promise.then((data) => {
                    tagRefBackup = _.orderBy(data, 'id')
                    return refreshTags() }).catch(ErrorCatcher)

                return resetTagPayload()
            }

            return activate()
        },
    }),
)
